var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExpertRuns(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 44 44",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.308 22.395L28.299 2.75l13.034 19.762-12.857 19.646-13.168-19.763z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.5 22.395L15.49 2.75l13.034 19.762-12.857 19.646L2.5 22.395z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpertRuns);
var MemoForwardRef = /*#__PURE__*/React.memo(ForwardRef);
export default "data:image/svg+xml,%3csvg viewBox='0 0 44 44' xmlns='http://www.w3.org/2000/svg'%3e %3cpath d='M15.308 22.3955L28.2994 2.75003L41.3326 22.5119L28.4757 42.158L15.308 22.3955Z'/%3e %3cpath d='M2.49944 22.3955L15.4908 2.75003L28.524 22.5119L15.6671 42.158L2.49944 22.3955Z'/%3e %3c/svg%3e";
export { MemoForwardRef as ReactComponent };